<template>
	<pre v-html="$t('terms.legal_indication9')"></pre>
</template>

<script>
export default {
	name: 'LegalIndication9',
};
</script>

<style scoped></style>
